import React, { useState } from 'react';
import { ShieldCheck, Zap, Shield, CreditCard, Check } from 'lucide-react';
const PLANS = [{
  id: 'premium',
  name: 'PACK COMPLETO',
  emoji: '🏆',
  description: 'TDLO 360 + Proyecto Integrador + 100 Micro-emprendimientos + Bonos',
  originalPrice: '$79.990',
  price: '$26.990',
  badge: 'MÁS ELEGIDO',
  savingsBadge: 'AHORRÁS $7.000',
  href: 'https://checkout.rincondigital.shop/cart/52931301671187:1',
  details: ['Sistema completo TDLO 360 (12 módulos)', 'Proyecto Integrador: Empresa Real de Barrio', '100 Micro-emprendimientos Ganadores', '2 Bonos exclusivos gratis', 'Acceso inmediato y vitalicio']
}, {
  id: 'standard',
  name: 'TDLO 360',
  emoji: '📘',
  description: '12 módulos completos + Bonos',
  originalPrice: '$49.990',
  price: '$19.990',
  badge: null,
  savingsBadge: null,
  href: 'https://checkout.rincondigital.shop/cart/52931287646483:1',
  details: ['Sistema completo TDLO 360 (12 módulos)', '2 Bonos exclusivos gratis', 'Acceso inmediato y vitalicio']
}];
export function PurchaseSection() {
  const [selectedPlan, setSelectedPlan] = useState('premium');
  const activePlan = PLANS.find(p => p.id === selectedPlan)!;
  return <section id="compra" className="py-12 md:py-16 px-4 bg-blue-950 text-white relative overflow-hidden" data-id="element-315">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-316" />

      <div className="max-w-lg mx-auto relative z-10" data-id="element-317">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-318">
          <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-319">
            Elegí tu plan
          </h2>
          <p className="text-blue-300 text-sm" data-id="element-320">
            Acceso inmediato después del pago
          </p>
        </div>

        {/* Plan Options */}
        <div className="space-y-3 mb-6" data-id="element-321">
          {PLANS.map(plan => {
          const isSelected = selectedPlan === plan.id;
          const isPremium = plan.id === 'premium';
          return <button key={plan.id} onClick={() => setSelectedPlan(plan.id)} className={`w-full text-left rounded-xl p-4 md:p-5 transition-all border-2 ${isSelected ? isPremium ? 'border-orange-400 bg-orange-950/40' : 'border-blue-400 bg-blue-900/60' : 'border-white/10 bg-white/5 hover:border-white/25'}`} data-id="element-322">
                <div className="flex items-start gap-3" data-id="element-323">
                  {/* Radio */}
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${isSelected ? isPremium ? 'border-orange-400' : 'border-blue-400' : 'border-white/30'}`} data-id="element-324">
                    {isSelected && <div className={`w-2.5 h-2.5 rounded-full ${isPremium ? 'bg-orange-400' : 'bg-blue-400'}`} data-id="element-325" />}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-326">
                    <div className="flex items-center gap-2 flex-wrap mb-1" data-id="element-327">
                      <span className="text-lg" data-id="element-328">{plan.emoji}</span>
                      <span className="font-bold text-white text-base" data-id="element-329">
                        {plan.name}
                      </span>
                      {plan.badge && <span className="bg-orange-500 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-330">
                          ⭐ {plan.badge}
                        </span>}
                      {plan.savingsBadge && <span className="bg-green-600 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-331">
                          {'AHORR\xC1S $30.000'}
                        </span>}
                    </div>
                    <p className="text-sm text-blue-200/80" data-id="element-332">
                      {plan.description}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0" data-id="element-333">
                    <div className="text-white/40 text-sm line-through" data-id="element-334">
                      {plan.originalPrice}
                    </div>
                    <div className={`font-black text-2xl ${isPremium ? 'text-orange-400' : 'text-white'}`} data-id="element-335">
                      {plan.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Button */}
        <a href={activePlan.href} className="block w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white rounded-xl shadow-xl shadow-orange-500/30 hover:shadow-orange-500/50 transition-all py-4 text-center mb-3" data-id="element-336">
          <div className="font-bold text-lg uppercase tracking-wide" data-id="element-337">
            SÍ, QUIERO{' '}
            {selectedPlan === 'premium' ? 'PACK COMPLETO' : 'ACCESO INMEDIATO'}{' '}
            →
          </div>
        </a>

        {/* Subtitle under button */}
        <p className="text-center text-sm text-blue-300/70 italic mb-6" data-id="element-338">
          {selectedPlan === 'premium' ? 'La opción más elegida por docentes que quieren todo resuelto' : 'Acceso inmediato al sistema completo TDLO 360'}
        </p>

        {/* Details panel for selected plan */}
        <div className="bg-white/5 border border-white/10 rounded-xl p-5 mb-6" data-id="element-339">
          <h4 className="font-bold text-white text-sm mb-3 uppercase tracking-wide" data-id="element-340">
            {selectedPlan === 'premium' ? '🏆 Tu Pack Completo incluye:' : '📘 Tu plan incluye:'}
          </h4>
          <ul className="space-y-2" data-id="element-341">
            {activePlan.details.map((detail, i) => <li key={i} className="flex items-start gap-2 text-sm text-blue-100" data-id="element-342">
                <Check className="w-4 h-4 text-green-400 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-343" />
                <span data-id="element-344">{detail}</span>
              </li>)}
          </ul>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-blue-300/60" data-id="element-345">
          <div className="flex items-center gap-1.5" data-id="element-346">
            <ShieldCheck className="h-3.5 w-3.5" data-id="element-347" />
            <span data-id="element-348">Pago seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-349">
            <Zap className="h-3.5 w-3.5" data-id="element-350" />
            <span data-id="element-351">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-352">
            <Shield className="h-3.5 w-3.5" data-id="element-353" />
            <span data-id="element-354">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-355">
            <CreditCard className="h-3.5 w-3.5" data-id="element-356" />
            <span data-id="element-357">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}